import axios from 'axios'
const baseURL = 'http://18.142.153.80:9999'
import * as configuretion from '../middleware/configuration'
const defaultOptions = {
    baseURL: baseURL,
    headers: {
        'Content-Type': 'application/json',
    },
};
const instance = axios.create(defaultOptions)

instance.interceptors.request.use(async (config) => {
    const token = await configuretion.getIdToken()
    if (token) {
        config.headers.Authorization = token ? `Bearer ${token}` : '';
        const uid = await configuretion.getUid()
        config.headers.Uid = uid
    }
    return config;
});

export default instance